import React, { useEffect, useRef, useState } from "react";
import Button from "./Button";
import { ReactComponent as ScrollFurtherSvg } from "../assets/svg/scroll-further.svg";
import SnowFlakes from "./snowFlakes/SnowFlakes";
import { LazyLoadImage } from "react-lazy-load-image-component";
import mountainsImg from "../assets/img/background/transtition-mountains.png";
import transitionLogoImg from "../assets/img/Transition-Logo.png";
import backgroundImg from "../assets/img/background/transition.png";
import "../css/main-transition-layer.css";

const MainTransitionLayer = () => {
  const [scrollY, setScrollY] = useState(0);
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  const layerRef = useRef(null);

  const handleScroll = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function scrollFurther() {
    window.scrollTo({
      top:
        (layerRef && layerRef.current.getBoundingClientRect().height) ||
        window.innerHeight,
      behavior: "smooth",
    });
  }

  // Вычисляем прозрачность
  const calculateOpacity = () => {
    if (isButtonHovered) return 1; // Полная видимость при наведении
    console.log(Math.max(0, 1 - scrollY / 500));
    return Math.max(0, 1 - scrollY / 500); // Чем больше scrollY, тем ниже opacity
  };

  return (
    <div
      ref={layerRef}
      className="main-transition-layer"
      style={{
        overflow: "hidden",
      }}
    >
      <div
        className="transition-logo center"
        style={{
          transform: `translateY(${scrollY * 0.5}px)`, // Эффект параллакса
        }}
      >
        <LazyLoadImage
          src={transitionLogoImg}
          alt="полное погружение с MEGALODON"
          className="main-transition-layer-text"
        />
      </div>
      <div
        className="action-buttons center"
        style={{
          opacity: calculateOpacity(),
          transition: "opacity 0.3s ease", // Плавное изменение прозрачности
        }}
      >
        <Button
          className="start-diving no-background accent spiked"
          onClick={scrollFurther}
          onMouseEnter={() => setIsButtonHovered(true)} // При наведении
          onMouseLeave={() => setIsButtonHovered(false)} // При выходе указателя
        >
          НАЧАТЬ ПОГРУЖЕНИЕ
        </Button>
        <div className="scroll-further text-dark">
          <ScrollFurtherSvg />
          <span>Листай дальше, чтобы узнать больше</span>
        </div>
      </div>
      <SnowFlakes />
    </div>
  );
};

export default MainTransitionLayer;
